var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l2 = _vm.__map(_vm.tableData, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var l0 = item.type == "radio" ? _vm.getName(item.select_value) : null
    var l1 =
      item.type == "radio-group"
        ? _vm.__map(_vm.getName(item.select_value), function (ritem, rindex) {
            var $orig = _vm.__get_orig(ritem)
            var m0 = _vm.getRadioGroup(index, ritem)
            return {
              $orig: $orig,
              m0: m0,
            }
          })
        : null
    var m1 = item.type == "select" ? _vm.getName(item.select_value) : null
    return {
      $orig: $orig,
      l0: l0,
      l1: l1,
      m1: m1,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, ritem, index) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        ritem = _temp2.ritem,
        index = _temp2.index
      var _temp, _temp2
      return _vm.changeRadioGroup(ritem, index)
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }